import { defineEvent } from '../types/event';
export var COUPON_MODAL_MICRO_YES_STEP_VIEW = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        }
    ]
});
